/**
 * Coordinates RegionGuard with the other region-aware redirects (AuthLayout,
 * TeacherLayout, StudentLayout, DashboardLayoutClient) that all react to the
 * same `user` state transition.
 *
 * Those guards now build their own fully region-correct target (via
 * getRegionLocaleHref() + the user's actual region), so RegionGuard's own
 * correction is redundant whenever one of them already navigated - and
 * worse than redundant, since RegionGuard reads `window.location.pathname`
 * synchronously and would "correct" the page being navigated *away* from,
 * racing the in-flight navigation. RegionGuard is a parent of every one of
 * these guards, so React runs its effect in the same commit, right after
 * theirs - marking the lock in their effect is guaranteed to be visible to
 * RegionGuard's effect the moment it runs.
 */
let handledInThisCommit = false;

export function markRegionNavigationHandled(): void {
  handledInThisCommit = true;
}

export function consumeRegionNavigationHandled(): boolean {
  const was = handledInThisCommit;
  handledInThisCommit = false;
  return was;
}
